/*
 * @Author: mike 13773159347@126.com
 * @Date: 2022-09-19 16:55:34
 * @LastEditors: mike 13773159347@126.com
 * @LastEditTime: 2022-11-23 11:02:19
 * @FilePath: \recruit\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import '@/assets/styles/index.scss' // global css
import './assets/styles/element-variables.scss'
import './assets/fonts/iconfont.css'
import router from './router'
import Element from 'element-ui'
import vshare from 'vshare'
import axios from './axios/axios'
import VueClipboard from 'vue-clipboard2'
import vueFilePreview from 'gxd-file-preview';
import VueSession from 'vue-session'
import moment from "moment"
Vue.prototype.$moment = moment;
// import Base64 from 'js-base64'
Vue.config.productionTip = false
// 挂载到prototype上，在组件中可以直接使用this.axios访问
Vue.prototype.axios = axios

Vue.use(VueSession)
// Vue.use(Base64)
Vue.use(Element)
Vue.use(vshare)
Vue.use(VueClipboard)
// Vue.use(vueFilePreview)

Vue.use(vueFilePreview,{
  pdf: 'http://openapi.qtechglobal.com:8003/js/pdf.min.js', //pdf插件
  worker: 'http://openapi.qtechglobal.com:8003/js/pdf.worker.min.js', //pdf.work插件
  // pdf: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.288/build/pdf.min.js', //pdf插件
  // worker:'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.288/build/pdf.worker.min.js',//pdf.work插件
});
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
   // chrome
   document.body.scrollTop = 0;
   // firefox
   document.documentElement.scrollTop = 0;
   // safari
   window.pageYOffset = 0;
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
    next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js